import { useContext } from 'react';
import EntitlementContext from 'context/EntitlementContext';

/**
 * Read the store's plan entitlements.
 *
 * Called with a feature code it answers for that one feature; called with no
 * argument it exposes the whole context, for components that need usage
 * counters or several features at once.
 *
 * @param {String} [featureCode] feature code, e.g. 'ai_summary'
 * @returns {object} entitlement helpers, plus `isEnabled`/`limit` when a code is given
 */

const useEntitlement = (featureCode) => {
  const context = useContext(EntitlementContext);

  // Guards against use outside the provider, so a gate degrades to locked
  // rather than throwing and taking the page down with it.
  if (!context) {
    return {
      isEnabled: false,
      limit: 0,
      hasFeature: () => false,
      getLimit: () => 0,
      entitlements: {},
      usage: {},
      plan: null,
      loading: false,
      isResolved: true,
    };
  }

  if (!featureCode) {
    return context;
  }

  return {
    ...context,
    isEnabled: context.hasFeature(featureCode),
    limit: context.getLimit(featureCode),
  };
};

export default useEntitlement;
